module.exports = __webpack_public_path__ + "img/bottom_gzh.36badfd7.png";